module.exports = __webpack_public_path__ + "media/images/favicon-d56d28aadd2a7637fa60e4631946d4a2.ico";